var render = function render(){var _vm=this,_c=_vm._self._c;return (
    typeof _vm.jsonData.list !== 'undefined' &&
      typeof _vm.jsonData.config !== 'undefined'
  )?_c('a-form',{staticClass:"k-build-form",style:({
    width: _vm.jsonData.config.width,
    marginTop: _vm.jsonData.config.marginTop,
    marginRight: _vm.jsonData.config.marginRight,
    marginBottom: _vm.jsonData.config.marginBottom,
    marginLeft: _vm.jsonData.config.marginLeft
  }),attrs:{"layout":_vm.jsonData.config.layout,"hideRequiredMark":_vm.jsonData.config.hideRequiredMark,"form":_vm.form},on:{"submit":_vm.handleSubmit}},_vm._l((_vm.jsonData.list),function(record,index){return _c('buildBlocks',{key:index,attrs:{"record":record,"config":_vm.jsonData.config},on:{"handleReset":_vm.handleReset}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }